import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    params: {
      lang: 'nl'
    }
  },
  {
    path: '/:lang',
    redirect: '/'
    // name: 'home',
    // component: Home
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    this.apps[0].$store.commit('setLanguage', { 'lang': to.params.lang })
  }
})

export default router
